import { Plus } from "lucide-react";
import { useMemo } from "react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { canCreateSKU } from "@/lib/permissions";
import useStore from "@/state";

export const CreateSKUButton = () => {
  const { session } = useStore();

  const createSKUAllowed = useMemo(
    () => canCreateSKU(session?.permissions),
    [session],
  );

  if (!createSKUAllowed) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <Button disabled>
              <Plus /> Create SKU
            </Button>
          </TooltipTrigger>
          <TooltipContent className="bg-popover shadow-md border">
            <p className="text-sm text-popover-foreground">
              Contact Legitimate or your account admin to update your role and
              permissions.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <Link to="/skus/create">
      <Button>
        <Plus /> Create SKU
      </Button>
    </Link>
  );
};
